export default "__VITE_ASSET___$zJuWdc__"